import React, { FC } from 'react';
import { Route, Switch } from 'react-router-dom';
import  WeeklyTechDashboard from './WeeklyTechDashboard';
import WeeklyTechDetails from './WeeklyTechDetails';

export interface WeeklyTechProps { }

const WeeklyTech: FC<WeeklyTechProps> = (props) => {

    return (
        <Switch>
            <Route exact path={'/dashboard/weekly-tech'} component={WeeklyTechDashboard} />
            <Route exact path={'/dashboard/weekly-tech/:id'} component={WeeklyTechDetails} />
        </Switch>
    )
}
export default WeeklyTech;